export default "__VITE_ASSET__a223nEEJ__"